<script setup lang="ts">
import { useUserStore } from "@/utils/UserStore";

const userStore = useUserStore();
const { closeInactivityLoggedOutNotice } = userStore
const { showInactivityLoggedOutNotice } = storeToRefs(userStore);
</script>
<template>
  <v-dialog
    v-model="showInactivityLoggedOutNotice"
    persistent
    no-click-animation
    max-width="600"
  >
    <v-card>
      <v-card-text>
        You have been logged out due to inactivity.
      </v-card-text>
      <v-card-actions>
        <v-btn variant="flat" color="secondary" @click="closeInactivityLoggedOutNotice">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
